import { PerimetersService } from './../../../../@core/utils/perimeters.service';
import { CommonModule } from '@angular/common';
import { Component, Input, Signal } from '@angular/core';
import { NbAccordionModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogRef, NbDialogService, NbInputModule, NbSpinnerModule } from '@nebular/theme';
import { KPI } from '../../../../@core/api';
import { I18nService, InvestmentsService, RoadmapService } from '../../../../@core/utils';
import { BaseSelectableListComponent } from '../base-selectable-list/base-selectable-list.component';
import * as R from 'ramda';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrencyPipe } from '../../../pipes';
import { first, Observable, of } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { arrayToIdMap, IdMap } from '../../../../@core/utils/scope.service';
import { SideFormDialogComponent } from '../side-form-dialog/side-form-dialog.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-investments-selectable-list',
  standalone: true,
  imports: [
    CommonModule,
    NbCardModule,
    TranslateModule,
    NbSpinnerModule,
    CurrencyPipe,
    NbCheckboxModule,
    NbAccordionModule,
    NbButtonModule,
    FormsModule,
    NbInputModule,
  ],
  templateUrl: './investments-selectable-list.component.html',
  styleUrl: '../base-form/base-form.component.scss',
})
export class InvestmentsSelectableListComponent extends BaseSelectableListComponent<KPI.Investment> {

  @Input() public perimeter: KPI.Perimeter;
  @Input() public startYear: number;
  @Input() public endYear: number;
  @Input() public title = this.translate.instant('Investments');
  @Input() public removeHypothesis = false;
  @Input() public currentAssetId?: number;

  public currency: string = '€';

  public roadmapIndicatorsMap: Signal<IdMap<KPI.RoadmapIndicator>>;

  constructor(
    protected nbDialogRef: NbDialogRef<InvestmentsSelectableListComponent>,
    protected dialogService: NbDialogService,
    protected investmentsService: InvestmentsService,
    protected translate: TranslateService,
    protected i18nService: I18nService,
    protected roadmapService: RoadmapService,
  ) {
    super(nbDialogRef, dialogService);
    this.currency = this.i18nService.getCurrency();
    this.roadmapIndicatorsMap = toSignal(
      this.roadmapService.roadmapIndicators().pipe(arrayToIdMap()),
    );
  }

  protected getAllElements$(): Observable<KPI.Investment[]> {
    if (!this.perimeter) {
      return of([]);
    }

    return this.investmentsService.loadInvestments(
      R.range(1950, 2100),
      PerimetersService.getBuildingsIds([this.perimeter]),
      null,
      null,
      true,
    ).pipe(first());
  }

  public getRoadmapIndicatorsString(investment: KPI.Investment) {
    return investment.impact_roadmap_indicators?.map((indicatorId) => {
      return this.roadmapIndicatorsMap()[indicatorId].name;
    }).join(', ');
  }

  protected showInNotLinkedElements(investment: KPI.Investment): boolean {
    if (this.removeHypothesis && investment.status_object?.hypothesis) {
      return false;
    }

    if (this.currentAssetId !== undefined) {
      return !investment.asset || investment.asset === this.currentAssetId;
    }

    return true;
  }

  public isInPeriod(investment: KPI.Investment): boolean {
    const investmentYear = investment.final_schedule_to;
    return investment.final_schedule_to <= this.endYear && investmentYear >= this.startYear;
  }

  public notLinkedElementChecked(element: KPI.Investment): void {
    if (!this.isInPeriod(element)) {
      this.dialogService.open(
        SideFormDialogComponent,
        {
          autoFocus: false,
          context: {
            title: this.translate.instant('Dates consistency'),
            content: this.translate.instant('The investment date does not match the bouquet of works period'),
            canCancel: false,
          },
        },
      )
    }
  }
}
